import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { KompisProductList } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

import { applicationSettings } from '../../settings/application';
import {
  getShoppingItemsFromTAC,
  getShoppingProductsFromTAC,
} from '../../util/aactools/kompisConvert';
import platform from '../../util/platform';
import { getCheckoutAvailabilityService } from '../../services/ServiceHandler';

import styles from './ProductList.module.less';
import { selectKompisTranslations } from '../../state/translations/translationsSelectors';
import { selectDexfSettings } from '../../state/dexfSettings/dexfSettingsSelectors';
import { selectTac } from '../../state/tac/tacSelectors.ts';

const ProductList = ({ tac, kompisTranslations, dexfSettings }) => {
  const { storeId } = applicationSettings;

  const shoppingProducts = tac ? getShoppingProductsFromTAC(tac) : [];
  const isKiosk = platform.isKiosk;

  const [storeAvailabilities, setStoreAvailabilities] = React.useState(null);
  const [visibleEnergyLabelCard, setVisibleEnergyLabelCard] =
    React.useState(null);
  const [visibleModal, setVisibleModal] = React.useState(null);

  React.useEffect(() => {
    async function getStoreAvailabilities() {
      const productItems = getShoppingItemsFromTAC(tac, true);
      const storeAvailabilities = await (
        await getCheckoutAvailabilityService()
      ).getStoreAvailabilities(storeId, productItems);
      setStoreAvailabilities(storeAvailabilities);
    }
    if (storeId) {
      getStoreAvailabilities();
    }
  }, []);

  const _setVisibleEnergyLabelCard = event =>
    event?.detail?.visibleEnergyLabelCard
      ? setVisibleEnergyLabelCard(event.detail.visibleEnergyLabelCard)
      : setVisibleEnergyLabelCard(null);

  const _setVisibleModal = event =>
    event?.detail?.visibleModal
      ? setVisibleModal(event.detail.visibleModal)
      : setVisibleModal(null);

  return (
    <div className={styles.productList}>
      <div
        className={classNames(
          styles.productListContainer,
          isKiosk && styles.productListKiosk
        )}
      >
        <KompisProductList
          shoppingProducts={shoppingProducts}
          translations={kompisTranslations}
          settings={dexfSettings}
          theme={SkapaTheme}
          visibleEnergyLabelCard={visibleEnergyLabelCard}
          onCloseEnergyLabelCard={_setVisibleEnergyLabelCard}
          onEnergyEfficiencyClassClicked={_setVisibleEnergyLabelCard}
          showItemNo={true}
          showDesignText={true}
          productMeasures={'long'}
          disableLinks={true}
          storeAvailabilities={storeAvailabilities}
          onModalOpen={_setVisibleModal}
          onModalClose={_setVisibleModal}
          visibleModal={visibleModal}
        />
      </div>
    </div>
  );
};

ProductList.propTypes = {
  tac: PropTypes.object,
  kompisTranslations: PropTypes.object.isRequired,
  dexfSettings: PropTypes.object.isRequired,
};

export default connect(state => ({
  kompisTranslations: selectKompisTranslations(state),
  dexfSettings: selectDexfSettings(state),
  tac: selectTac(state),
}))(ProductList);
